import React, { useContext, useEffect, useReducer, useState } from "react";
import { ProspectionMasterMenuGate } from "../components/ProspectionMasterGate";
import { Link as RouterLink, useLocation, useHistory } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useHelps from "../hooks/useHelps";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import SearchIcon from "@material-ui/icons/Search";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import ViewKanban from "@mui/icons-material/ViewKanban";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import Schedule from "@material-ui/icons/Schedule";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import RouterIcon from "@material-ui/icons/Router";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ForumIcon from "@material-ui/icons/Forum";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import {
  AllInclusive,
  AttachFile,
  Dashboard,
  Description,
  DeviceHubOutlined,
  SettingsApplications
} from "@material-ui/icons";

// NOVO ÍCONE PARA CONEXÕES
import SignalCellularConnectedNoInternet4BarIcon from "@material-ui/icons/SignalCellularConnectedNoInternet4Bar";

import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import { useActiveMenu } from "../context/ActiveMenuContext";

import { Can } from "../components/Can";

import { isArray } from "lodash";
import api from "../services/api";
import toastError from "../errors/toastError";
import usePlans from "../hooks/usePlans";
import useVersion from "../hooks/useVersion";
import { i18n } from "../translate/i18n";
import { ShapeLine, Webhook } from "@mui/icons-material";

// 1. DEFINIÇÃO DAS CORES DOS ÍCONES
const iconStyles = {
  dashboard: { color: "#155eef", gradient: "linear-gradient(135deg, #1f6ef5 0%, #155eef 100%)" },
  tickets: { color: "#0e9384", gradient: "linear-gradient(135deg, #1ca39b 0%, #0e9384 100%)" },
  email: { color: "#7F56D9", gradient: "linear-gradient(135deg, #9E77ED 0%, #6941C6 100%)" },
  messages: { color: "#f79009", gradient: "linear-gradient(135deg, #fdb022 0%, #f79009 100%)" },
  kanban: { color: "#0ba5ec", gradient: "linear-gradient(135deg, #36bffa 0%, #0ba5ec 100%)" },
  contacts: { color: "#12b76a", gradient: "linear-gradient(135deg, #32d583 0%, #12b76a 100%)" },
  schedules: { color: "#f63d68", gradient: "linear-gradient(135deg, #fd6f8e 0%, #f63d68 100%)" },
  agenda: { color: "#2563eb", gradient: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)" },
  tags: { color: "#f67021", gradient: "linear-gradient(135deg, #fd853a 0%, #f67021 100%)" },
  chats: { color: "#6172f3", gradient: "linear-gradient(135deg, #8098f9 0%, #6172f3 100%)" },
  helps: { color: "#0284c7", gradient: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)" },
  campaigns: { color: "#d92d20", gradient: "linear-gradient(135deg, #f04438 0%, #d92d20 100%)" },
  flowbuilder: { color: "#7a5af8", gradient: "linear-gradient(135deg, #9e77ed 0%, #7a5af8 100%)" },
  announcements: { color: "#dc6803", gradient: "linear-gradient(135deg, #f79009 0%, #dc6803 100%)" },
  api: { color: "#087443", gradient: "linear-gradient(135deg, #12b76a 0%, #087443 100%)" },
  users: { color: "#444ce7", gradient: "linear-gradient(135deg, #6172f3 0%, #444ce7 100%)" },
  queues: { color: "#0e9384", gradient: "linear-gradient(135deg, #15b79e 0%, #0e9384 100%)" },
  prompts: { color: "#9e77ed", gradient: "linear-gradient(135deg, #b692f6 0%, #9e77ed 100%)" },
  integrations: { color: "#ef6820", gradient: "linear-gradient(135deg, #f38744 0%, #ef6820 100%)" },
  connections: { color: "#475467", gradient: "linear-gradient(135deg, #667085 0%, #475467 100%)" },
  files: { color: "#1570ef", gradient: "linear-gradient(135deg, #53b1fd 0%, #1570ef 100%)" },
  financial: { color: "#039855", gradient: "linear-gradient(135deg, #12b76a 0%, #039855 100%)" },
  settings: { color: "#363f72", gradient: "linear-gradient(135deg, #6172f3 0%, #363f72 100%)" },
  companies: { color: "#026aa2", gradient: "linear-gradient(135deg, #0ba5ec 0%, #026aa2 100%)" },
  globalConfig: { color: "#6941c6", gradient: "linear-gradient(135deg, #875bf7 0%, #6941c6 100%)" },
  server: { color: "#0f766e", gradient: "linear-gradient(135deg, #14b8a6 0%, #0f766e 100%)" },
  default: { color: "#155eef", gradient: "linear-gradient(135deg, #1f6ef5 0%, #155eef 100%)" }
};

const useStyles = makeStyles((theme) => ({
  menuRoot: {
    padding: "6px 6px 10px",
  },
  listItem: {
    height: 38,
    marginBottom: 2,
    borderRadius: 9,
    paddingLeft: 8,
    paddingRight: 8,
    transition: "all 0.15s ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.06)",
    },
  },
  listItemIconOnly: {
  justifyContent: "center",
  paddingLeft: 6,
  paddingRight: 6,
  height: 44,
  marginBottom: 6,
},
  listItemCompact: {
    height: 34,
    marginBottom: 1,
    marginLeft: 6,
    marginRight: 6,
    paddingLeft: 8,
  },
  listItemActive: {
    backgroundColor: "rgba(255,255,255,0.07)",
    "& $listItemLabel": {
      fontWeight: 600,
      color: "#ffffff",
    },
  },
  listItemIcon: {
    minWidth: 40,
  },
  listItemIconOnlyWrap: {
  minWidth: "auto",
  margin: 0,
  display: "flex",
  justifyContent: "center",
},
  listItemText: {
    margin: 0,
  },
  listItemLabel: {
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: "0.01em",
    color: "#C8D3E8",
    lineHeight: 1.2,
  },
  sectionDivider: {
    margin: "8px 8px 4px",
    opacity: theme.mode === "light" ? 0.25 : 0.15,
  },
  listSubheader: {
    marginBottom: 2,
    paddingLeft: 10,
    fontSize: 9.5,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    color: "#4A5568",
    lineHeight: "18px",
    background: "transparent",
  },
  iconHoverActive: {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 11,
  height: 32,
  width: 32,
  transition: "all 0.15s ease",
  "& .MuiSvgIcon-root": {
    fontSize: "1.16rem",
  },
},
  submenuSection: {
    margin: "1px 0 6px",
    padding: "4px 0",
    borderRadius: 9,
    background:
      theme.mode === "light"
        ? "rgba(148,163,184,0.06)"
        : "rgba(255,255,255,0.03)",
  },
  groupExpandIcon: {
    color: theme.mode === "light" ? "#94a3b8" : "#64748b",
    fontSize: "1rem",
  },
  versionWrap: {
    padding: "10px 12px 6px",
    textAlign: "center",
  },
  versionChip: {
    background: theme.mode === "light"
      ? "rgba(21,94,239,0.07)"
      : "rgba(255,255,255,0.06)",
    border: theme.mode === "light"
      ? "1px solid rgba(21,94,239,0.12)"
      : "1px solid rgba(255,255,255,0.08)",
    color: theme.mode === "light" ? "#475569" : "#94a3b8",
    fontWeight: 600,
    fontSize: "0.68rem",
    letterSpacing: "0.03em",
  },
}));

function ListItemLink(props) {
  const { icon, primary, to, tooltip, showBadge, badgeCount, iconKey, small, guideId } = props;
  const classes = useStyles();
  const theme = useTheme();
  const { activeMenu } = useActiveMenu();
  const location = useLocation();
  const isActive = activeMenu === to || location.pathname === to;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  const iconStyle = iconStyles[iconKey] || iconStyles.default;
  const isIconOnly = !!tooltip;
  const iconSurfaceStyle = isActive
    ? {
        color: "#ffffff",
        background: iconStyle.gradient,
        boxShadow: "0 8px 16px -12px rgba(15, 23, 42, 0.65)",
      }
    : {
        color: "#ffffff",
        background: "linear-gradient(135deg, #1a3a7c 0%, #0f2357 100%)",
        border: "1px solid rgba(255,255,255,0.08)",
      };

  const ConditionalTooltip = ({ children, tooltipEnabled }) =>
    tooltipEnabled ? (
      <Tooltip
        placement="right"
        arrow
        title={
          <Typography style={{ fontWeight: 700, fontSize: "0.9rem" }}>
            {primary}
          </Typography>
        }
      >
        {children}
      </Tooltip>
    ) : (
      children
    );

  return (
    <ConditionalTooltip tooltipEnabled={!!tooltip}>
      <li>
        <ListItem
          button
          component={renderLink}
          data-guide={guideId}
          className={`${classes.listItem} ${
            isActive ? classes.listItemActive : ""
          } ${small ? classes.listItemCompact : ""} ${
            isIconOnly ? classes.listItemIconOnly : ""
          }`}
        >
          {icon ? (
            <ListItemIcon
              className={`${classes.listItemIcon} ${
                isIconOnly ? classes.listItemIconOnlyWrap : ""
              }`}
            >
              {showBadge ? (
                <Badge
                  badgeContent="!"
                  color="error"
                  overlap="circular"
                  className={classes.badge}
                >
                  <Avatar
                    variant="rounded"
                    className={classes.iconHoverActive}
                    style={iconSurfaceStyle}
                  >
                    {icon}
                  </Avatar>
                </Badge>
              ) : (
                <Avatar
                  variant="rounded"
                  className={classes.iconHoverActive}
                  style={iconSurfaceStyle}
                >
                  {icon}
                </Avatar>
              )}
            </ListItemIcon>
          ) : null}
          {!isIconOnly && (
            <ListItemText
              className={classes.listItemText}
              primary={
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width="100%"
                >
                  <Typography className={classes.listItemLabel}>
                    {primary}
                  </Typography>
                  {badgeCount > 0 && (
                    <Box
                      component="span"
                      style={{
                        background: "#DC2626",
                        color: "#FFFFFF",
                        borderRadius: 999,
                        minWidth: 24,
                        height: 22,
                        padding: "0 6px",
                        fontSize: 11,
                        fontWeight: 800,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: 8,
                        flexShrink: 0
                      }}
                    >
                      {badgeCount > 25 ? "25+" : badgeCount}
                    </Box>
                  )}
                </Box>
              }
            />
          )}
        </ListItem>
      </li>
    </ConditionalTooltip>
  );
}

const reducer = (state, action) => {
  if (action.type === "LOAD_CHATS") {
    const chats = action.payload;
    const newChats = [];

    if (isArray(chats)) {
      chats.forEach((chat) => {
        const chatIndex = state.findIndex((u) => u.id === chat.id);
        if (chatIndex !== -1) {
          state[chatIndex] = chat;
        } else {
          newChats.push(chat);
        }
      });
    }

    return [...state, ...newChats];
  }

  if (action.type === "UPDATE_CHATS") {
    const chat = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chat.id);

    if (chatIndex !== -1) {
      state[chatIndex] = chat;
      return [...state];
    } else {
      return [chat, ...state];
    }
  }

  if (action.type === "DELETE_CHAT") {
    const chatId = action.payload;

    const chatIndex = state.findIndex((u) => u.id === chatId);
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "CHANGE_CHAT") {
    const changedChats = state.map((chat) => {
      if (chat.id === action.payload.chat.id) {
        return action.payload.chat;
      }
      return chat;
    });
    return changedChats;
  }
};

const MainListItems = ({ collapsed, drawerClose }) => {
  const theme = useTheme();
  const classes = useStyles();
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user, socket } = useContext(AuthContext);

  // KORAX EMAIL ACCESS BY ASSIGNMENT V2
  const [
    showAssignedEmail,
    setShowAssignedEmail
  ] = useState(false);
  const { setActiveMenu } = useActiveMenu();
  const location = useLocation();
  const history = useHistory();

  const [emailUnreadCount, setEmailUnreadCount] = useState(0);

  useEffect(() => {
    if (!user?.id || !user?.companyId || !showAssignedEmail) {
      setEmailUnreadCount(0);
      return undefined;
    }

    let mounted = true;
    let loading = false;

    const refresh = async () => {
      if (loading || document.hidden) return;

      loading = true;

      try {
        const { data } = await api.get("/email-beta/unread-count", {
          timeout: 20000
        });

        if (mounted) {
          const count = Number(data?.unreadCount);
          setEmailUnreadCount(
            Number.isFinite(count) && count >= 0
              ? Math.min(26, Math.floor(count))
              : 0
          );
        }
      } catch (_) {
        if (mounted) {
          setEmailUnreadCount(0);
        }
      } finally {
        loading = false;
      }
    };

    const onVisibility = () => {
      if (!document.hidden) refresh();
    };

    refresh();

    const interval = window.setInterval(refresh, 60000);
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("korax:email-unread-changed", refresh);

    return () => {
      mounted = false;
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibility);
    window.removeEventListener("korax:email-unread-changed", refresh);
    };
  }, [user?.id, user?.companyId, showAssignedEmail]);

  const [connectionWarning, setConnectionWarning] = useState(false);
  const [openCampaignSubmenu, setOpenCampaignSubmenu] = useState(false);
  const [openFlowSubmenu, setOpenFlowSubmenu] = useState(false);
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);

  const [showSchedules, setShowSchedules] = useState(false);
  const [showAgenda, setShowAgenda] = useState(false);
  const [showInternalChat, setShowInternalChat] = useState(true);
  const [showExternalApi, setShowExternalApi] = useState(false);

  const [invisible, setInvisible] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam] = useState("");
  const [chats, dispatch] = useReducer(reducer, []);
  const [, setVersion] = useState(false);
  const [managementHover, setManagementHover] = useState(false);
  const [campaignHover, setCampaignHover] = useState(false);
  const [flowHover, setFlowHover] = useState(false);
  const { list } = useHelps();
  const [hasHelps, setHasHelps] = useState(false);

  useEffect(() => {
    async function checkHelps() {
      try {
        const helps = await list();
        setHasHelps(helps.length > 0);
      } catch (error) {
        if (error?.response?.status !== 401) {
          console.error("Erro ao carregar helps", error);
        }
      }
    }
    checkHelps();
  }, []);

  const isManagementActive =
    location.pathname === "/" ||
    location.pathname.startsWith("/reports") ||
    location.pathname.startsWith("/moments") ||
    location.pathname.startsWith("/server-metrics");

  const isCampaignRouteActive =
    location.pathname === "/disparos" ||
    location.pathname.startsWith("/disparos") ||
    location.pathname === "/campaigns" ||
    location.pathname.startsWith("/contact-lists") ||
    location.pathname.startsWith("/campaigns-config");

  const isFlowbuilderRouteActive =
    location.pathname.startsWith("/phrase-lists") ||
    location.pathname.startsWith("/flowbuilders");
  const inactiveIconSurface = {
    color: "#ffffff",
    background: "linear-gradient(135deg, #1a3a7c 0%, #0f2357 100%)",
    border: "1px solid rgba(255,255,255,0.08)",
  };

  useEffect(() => {
    if (location.pathname.startsWith("/tickets")) {
      setActiveMenu("/tickets");
    } else {
      setActiveMenu("");
    }
  }, [location, setActiveMenu]);

  const { getPlanCompany } = usePlans();

  const { getVersion } = useVersion();

  useEffect(() => {
    async function fetchVersion() {
      try {
        const _version = await getVersion();
        setVersion(_version.version);
      } catch (error) {
        if (error?.response?.status !== 401) {
          console.error("Erro ao carregar versão", error);
        }
      }
    }
    fetchVersion();
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    async function fetchData() {
      try {
        const companyId = user.companyId;
        const planConfigs = await getPlanCompany(undefined, companyId);

        setShowCampaigns(planConfigs.plan.useCampaigns);
        setShowKanban(true);
        setShowOpenAi(planConfigs.plan.useOpenAi);
        setShowIntegrations(planConfigs.plan.useIntegrations);
        setShowSchedules(true);
        setShowAgenda(true);
        // Chat interno e recurso operacional padrao da Korax.
        // Disponivel para admins e usuarios comuns autenticados.
        setShowInternalChat(true);
        setShowExternalApi(planConfigs.plan.useExternalApi);
      } catch (error) {
        if (error?.response?.status !== 401) {
          console.error("Erro ao carregar plano", error);
        }
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchChats();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber]);

  useEffect(() => {
    if (user.id) {
      const companyId = user.companyId;
      const onCompanyChatMainListItems = (data) => {
        if (data.action === "new-message") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
        if (data.action === "update") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
      };

      socket.on(`company-${companyId}-chat`, onCompanyChatMainListItems);
      return () => {
        socket.off(`company-${companyId}-chat`, onCompanyChatMainListItems);
      };
    }
  }, [socket]);

  useEffect(() => {
    let unreadsCount = 0;
    if (chats.length > 0) {
      for (let chat of chats) {
        for (let chatUser of chat.users) {
          if (chatUser.userId === user.id) {
            unreadsCount += chatUser.unreads;
          }
        }
      }
    }
    if (unreadsCount > 0) {
      setInvisible(false);
    } else {
      setInvisible(true);
    }
  }, [chats, user.id]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  const fetchChats = async () => {
    try {
      const { data } = await api.get("/chats/", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_CHATS", payload: data.records });
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {

    let mounted = true;


    if (!user?.id) {

      setShowAssignedEmail(false);

      return () => {
        mounted = false;
      };
    }


    if (user?.super) {

      setShowAssignedEmail(true);

      return () => {
        mounted = false;
      };
    }


    const loadAssignedEmail =
      async () => {

        try {

          const {
            data
          } =
            await api.get(
              "/email-beta/access/self"
            );


          if (mounted) {

            setShowAssignedEmail(
              Boolean(
                data?.enabled
              )
            );
          }

        } catch (err) {

          if (mounted) {

            setShowAssignedEmail(false);
          }
        }
      };


    loadAssignedEmail();


    return () => {

      mounted = false;
    };

  }, [
    user?.id,
    user?.companyId,
    user?.super
  ]);


  // ============================================================
  // KORAX SIMPLE EXPERIENCE
  //
  // Navegação essencial para clientes da Korax.
  // Simplifica a interface sem retirar recursos necessários
  // para ativação e gestão da operação.
  //
  // Superadmins continuam usando o menu completo abaixo.
  // ============================================================
  const simplifiedExperience = !user?.super;

  // KORAX SIGN PENSOU RELEASE V0.8C
  const isPensouSignUser =
    Number(
      user?.companyId
    ) === 72;

  if (simplifiedExperience) {
    const isClientAdmin = user.profile === "admin";

    const canManageWhatsapp =
      isClientAdmin ||
      (
        user.profile === "user" &&
        user.allowConnections === "enabled"
      );

    const SectionLabel = ({ children }) =>
      collapsed ? null : (
        <div
          style={{
            padding: "15px 16px 6px",
            fontSize: 9,
            fontWeight: 900,
            color: "#94A3B8",
            letterSpacing: ".08em",
            textTransform: "uppercase"
          }}
        >
          {children}
        </div>
      );

    return (
      <div
        onClick={drawerClose}
        className={classes.menuRoot}
      >
        {/* ================================================
            OPERAÇÃO
        ================================================= */}

        <SectionLabel>Operação</SectionLabel>

        <ListItemLink
          guideId="menu-home"
          to="/"
          primary="Início"
          icon={<Dashboard />}
          iconKey="dashboard"
          tooltip={collapsed}
        />

        <ListItemLink
          guideId="menu-conversations"
          to="/tickets"
          primary="Conversas"
          icon={<WhatsAppIcon />}
          iconKey="tickets"
          tooltip={collapsed}
        />

        {showAssignedEmail && (
          <ListItemLink
            guideId="menu-email-assigned"
            badgeCount={emailUnreadCount}
            to="/email"
            primary="E-mail"
            icon={<MailOutlineIcon />}
            iconKey="email"
            tooltip={collapsed}
          />
        )}

        {isPensouSignUser && (
          <ListItemLink
            guideId="menu-korax-sign-pensou"
            to="/documents"
            primary="Documentos"
            icon={
              <span
                style={{
                  fontSize: 16,
                  lineHeight: 1
                }}
              >
                ✍
              </span>
            }
            iconKey="files"
            tooltip={collapsed}
          />
        )}


        <ListItemLink
          guideId="menu-quick-messages"
          to="/quick-messages"
          primary="Respostas rápidas"
          icon={<FlashOnIcon />}
          iconKey="messages"
          tooltip={collapsed}
        />

        <ProspectionMasterMenuGate>
          <ListItemLink
                    guideId="menu-prospeccao"
                    to="/prospeccao"
                    primary="Prospecção"
                    icon={<SearchIcon />}
                    iconKey="contacts"
                    tooltip={collapsed}
                  />
        </ProspectionMasterMenuGate>

        <ListItemLink
          guideId="menu-crm"
          to="/crm"
          primary="CRM"
          icon={<MonetizationOnOutlinedIcon />}
          iconKey="financial"
          tooltip={collapsed}
        />

        {showAgenda && (
          <ListItemLink
            guideId="menu-agenda"
            to="/agenda"
            primary="Agenda"
            icon={<EventAvailableIcon />}
            iconKey="agenda"
            tooltip={collapsed}
          />
        )}

        {(
          user?.profile === "admin" ||
          user?.profile === "super" ||
          user?.super === true
        ) && (
          <ListItemLink
            guideId="menu-korax-forms"
            to="/formularios"
            primary="Formulários"
            icon={<AssignmentOutlinedIcon />}
            iconKey="contacts"
            tooltip={collapsed}
          />
        )}
        <ListItemLink
          guideId="menu-contacts"
          to="/contacts"
          primary="Clientes"
          icon={<ContactPhoneOutlinedIcon />}
          iconKey="contacts"
          tooltip={collapsed}
        />

        <ListItemLink
          guideId="menu-follow-up"
          to="/schedules"
          primary="Follow-up"
          icon={<Schedule />}
          iconKey="schedules"
          tooltip={collapsed}
        />

        <ListItemLink
          guideId="menu-tags"
          to="/tags"
          primary={i18n.t("mainDrawer.listItems.tags")}
          icon={<LocalOfferIcon />}
          iconKey="tags"
          tooltip={collapsed}
        />

        {/* Chat interno - disponivel para toda a equipe */}
        <ListItemLink
          guideId="menu-internal-chat"
          to="/chats"
          primary={i18n.t("mainDrawer.listItems.chats")}
          icon={
            <Badge
              color="secondary"
              variant="dot"
              overlap="rectangular"
              invisible={invisible}
            >
              <ForumIcon />
            </Badge>
          }
          iconKey="chats"
          tooltip={collapsed}
        />

        {/* ================================================
            IA - SOMENTE ADMIN DO CLIENTE
        ================================================= */}

        {isClientAdmin && showOpenAi && (
          <>
            {!collapsed && (
              <Divider
                className={classes.sectionDivider}
              />
            )}

            <SectionLabel>
              IA e automação
            </SectionLabel>

            <ListItemLink
              guideId="menu-train-ai"
              to="/korax-ia/treinamento"
              primary="Treinar IA"
              icon={<SmartToyOutlinedIcon />}
              iconKey="prompts"
              tooltip={collapsed}
            />

            <ListItemLink
              guideId="menu-ai-library-client"
              to="/korax-ia/biblioteca"
              primary="Biblioteca da IA"
              icon={
                <span style={{ fontSize: 16 }}>
                  📚
                </span>
              }
              iconKey="files"
              tooltip={collapsed}
            />
          </>
        )}

        {/* ================================================
            ADMINISTRATIVO

            Admin vê tudo.
            Usuário comum só entra aqui caso tenha
            permissão para gerenciar WhatsApp.
        ================================================= */}

        {(isClientAdmin || canManageWhatsapp) && (
          <>
            {!collapsed && (
              <Divider
                className={classes.sectionDivider}
              />
            )}

            <SectionLabel>
              Administrativo
            </SectionLabel>


            {canManageWhatsapp && (
              <ListItemLink
                guideId="menu-whatsapp"
                to="/connections"
                primary="WhatsApp"
                icon={
                  <SignalCellularConnectedNoInternet4BarIcon />
                }
                iconKey="connections"
                showBadge={connectionWarning}
                tooltip={collapsed}
              />
            )}

            {isClientAdmin && (
              <>
                <ListItemLink
                  guideId="menu-team"
                  to="/users"
                  primary="Equipe"
                  icon={<PeopleAltOutlinedIcon />}
                  iconKey="users"
                  tooltip={collapsed}
                />

                <ListItemLink
                  guideId="menu-campaigns-client"
                  to="/disparos"
                  primary="Campanhas"
                  icon={<EventAvailableIcon />}
                  iconKey="campaigns"
                  tooltip={collapsed}
                />

                <ListItemLink
                  guideId="menu-catalog-client"
                  to="/catalog"
                  primary="Catálogo"
                  icon={
                    <span style={{ fontSize: 16 }}>
                      🛍️
                    </span>
                  }
                  iconKey="catalog"
                  tooltip={collapsed}
                />

                <ListItemLink
                  guideId="menu-ai-credits-client"
                  to="/ai-credits"
                  primary="Créditos IA"
                  icon={
                    <span style={{ fontSize: 16 }}>
                      ⚡
                    </span>
                  }
                  iconKey="prompts"
                  tooltip={collapsed}
                />

                <ListItemLink
                  guideId="menu-financial"
                  to="/financeiro"
                  primary="Assinatura"
                  icon={<LocalAtmIcon />}
                  iconKey="financial"
                  tooltip={collapsed}
                />

                <ListItemLink
                  guideId="menu-queues"
                  to="/queues"
                  primary="Setores"
                  icon={<AccountTreeOutlinedIcon />}
                  iconKey="queues"
                  tooltip={collapsed}
                />

                <ListItemLink
                  guideId="menu-settings"
                  to="/settings"
                  primary="Configurações"
                  icon={<SettingsOutlinedIcon />}
                  iconKey="settings"
                  tooltip={collapsed}
                />
              </>
            )}
          </>
        )}

        {!collapsed && (
          <>
            <Divider
              className={classes.sectionDivider}
            />

            <Box className={classes.versionWrap}>
              <Chip
                label="V15.0.2"
                size="small"
                className={classes.versionChip}
              />
            </Box>
          </>
        )}
      </div>
    );
  }

  return (
    <div onClick={drawerClose} className={classes.menuRoot}>
      {(
        (user.profile === "user" && user.showDashboard === "enabled") ||
        user.profile === "admin" ||
        user.allowRealTime === "enabled"
      ) && (
        <ListItemLink
          to="/"
          primary={i18n.t("mainDrawer.listItems.management")}
          icon={<Dashboard />}
          iconKey="dashboard"
          tooltip={collapsed}
        />
      )}
        <ListItemLink
          guideId="menu-email-beta"
            badgeCount={emailUnreadCount}
          to="/email"
          primary="E-mail  BETA"
          icon={<MailOutlineIcon />}
          iconKey="email"
          tooltip={collapsed}
        />

        {/* KORAX SIGN V0.1 - MASTER ONLY */}
        <ListItemLink
          guideId="menu-korax-sign"
          to="/documents"
          primary="Documentos"
          icon={
            <span
              style={{
                fontSize: 16,
                lineHeight: 1
              }}
            >
              ✍
            </span>
          }
          iconKey="files"
          tooltip={collapsed}
        />

      <ListItemLink
        guideId="menu-conversations"
        to="/tickets"
        primary={i18n.t("mainDrawer.listItems.tickets")}
        icon={<WhatsAppIcon />}
        iconKey="tickets"
        tooltip={collapsed}
      />
      <ProspectionMasterMenuGate>
        <ListItemLink
          guideId="menu-prospeccao-master"
          to="/prospeccao"
          primary="Prospecção"
          icon={<SearchIcon />}
          iconKey="contacts"
          tooltip={collapsed}
        />
      </ProspectionMasterMenuGate>

      <ListItemLink
        guideId="menu-sales"
        to="/opportunities"
        primary="CRM"
        icon={<MonetizationOnOutlinedIcon />}
        iconKey="financial"
        tooltip={collapsed}
      />
      {(
        user?.profile === "admin" ||
        user?.profile === "super" ||
        user?.super === true
      ) && (
        <ListItemLink
          guideId="menu-korax-forms"
          to="/formularios"
          primary="Formulários"
          icon={<AssignmentOutlinedIcon />}
          iconKey="contacts"
          tooltip={collapsed}
        />
      )}
      <ListItemLink
        guideId="menu-contacts"
        to="/contacts"
        primary={i18n.t("mainDrawer.listItems.contacts")}
        icon={<ContactPhoneOutlinedIcon />}
        iconKey="contacts"
        tooltip={collapsed}
      />

      <ListItemLink
        guideId="menu-follow-up"
        to="/schedules"
        primary={i18n.t("mainDrawer.listItems.schedules")}
        icon={<Schedule />}
        iconKey="schedules"
        tooltip={collapsed}
      />
      <ListItemLink
        guideId="menu-sequences"
        to="/message-sequences"
        primary="Sequências"
        icon={<span style={{fontSize:16}}>⚡</span>}
        iconKey="dashboard"
        tooltip={collapsed}
      />

      {showAgenda && (
        <>
          <ListItemLink
            guideId="menu-agenda"
            to="/agenda"
            primary="Agenda"
            icon={<EventAvailableIcon />}
            iconKey="agenda"
            tooltip={collapsed}
          />
        </>
      )}

      
      {/* Recursos Korax disponíveis ao usuário da empresa */}
      <ListItemLink
        guideId="menu-ai-credits"
        to="/ai-credits"
        primary="Créditos IA"
        icon={<span style={{fontSize:16}}>⚡</span>}
        iconKey="prompts"
        tooltip={collapsed}
      />

      <ListItemLink
        guideId="menu-ai-library"
        to="/korax-ia/biblioteca"
        primary="Biblioteca Korax IA"
        icon={<span style={{fontSize:16}}>📚</span>}
        iconKey="files"
        tooltip={collapsed}
      />

      {user.profile === "user" && (
        <ListItemLink
          guideId="menu-campaigns-user"
          to="/disparos"
          primary={i18n.t("mainDrawer.listItems.campaigns")}
          icon={<EventAvailableIcon />}
          iconKey="campaigns"
          tooltip={collapsed}
        />
      )}

<ListItemLink
        guideId="menu-catalog"
        to="/catalog"
        primary="Catálogo"
        icon={<span style={{fontSize:16}}>🛍️</span>}
        iconKey="catalog"
        tooltip={collapsed}
      />

      <ListItemLink
        guideId="menu-tags"
        to="/tags"
        primary={i18n.t("mainDrawer.listItems.tags")}
        icon={<LocalOfferIcon />}
        iconKey="tags"
        tooltip={collapsed}
      />

      {showInternalChat && (
        <>
          <ListItemLink
            to="/chats"
            primary={i18n.t("mainDrawer.listItems.chats")}
            icon={
              <Badge
                color="secondary"
                variant="dot"
                overlap="rectangular"
                invisible={invisible}
              >
                <ForumIcon />
              </Badge>
            }
            iconKey="chats"
            tooltip={collapsed}
          />
        </>
      )}

      {hasHelps && (
        <ListItemLink
          to="/helps"
          primary={i18n.t("mainDrawer.listItems.helps")}
          icon={<HelpOutlineIcon />}
          iconKey="helps"
          tooltip={collapsed}
        />
      )}

      <Can
        role={
          user.profile === "user" &&
          user.allowConnections === "enabled"
            ? "admin"
            : user.profile
        }
        perform="dashboard:view"
        yes={() => (
          <>
            {!collapsed && (
              <>
                <Divider className={classes.sectionDivider} />
                <ListSubheader inset className={classes.listSubheader}>
                  {i18n.t("mainDrawer.listItems.administration")}
                </ListSubheader>
              </>
            )}
            
            
{user.profile !== "user" && showCampaigns && (
              <Can
                role={user.profile}
                perform="dashboard:view"
                yes={() => (
                  <>
                    <Tooltip
                      placement="right"
                      arrow
                      title={
                        collapsed ? (
                          <Typography
                            style={{
                              fontWeight: 700,
                              fontSize: "0.9rem",
                            }}
                          >
                            {i18n.t(
                              "mainDrawer.listItems.campaigns"
                            )}
                          </Typography>
                        ) : (
                          ""
                        )
                      }
                    >
                      <ListItem
                        data-guide="menu-campaigns"
                        dense
                        button
                        className={`${classes.listItem} ${
                          isCampaignRouteActive
                            ? classes.listItemActive
                            : ""
                        } ${collapsed ? classes.listItemIconOnly : ""}`}
                        onClick={() => history.push("/disparos")}
                        onMouseEnter={() => setCampaignHover(true)}
                        onMouseLeave={() => setCampaignHover(false)}
                      >
                        <ListItemIcon
                          className={`${classes.listItemIcon} ${
                            collapsed ? classes.listItemIconOnlyWrap : ""
                          }`}
                        >
                          <Avatar
                            variant="rounded"
                            className={classes.iconHoverActive}
                            style={
                              isCampaignRouteActive || campaignHover
                                ? {
                                    color: "#ffffff",
                                    background:
                                      iconStyles.campaigns.gradient,
                                    boxShadow:
                                      "0 8px 16px -12px rgba(15, 23, 42, 0.65)",
                                  }
                                : {
                                    color: iconStyles.campaigns.color,
                                    ...inactiveIconSurface,
                                  }
                            }
                          >
                            <EventAvailableIcon />
                          </Avatar>
                        </ListItemIcon>
                        {!collapsed && (
                          <ListItemText
                            className={classes.listItemText}
                            primary={
                              <Typography className={classes.listItemLabel}>
                                {i18n.t(
                                  "mainDrawer.listItems.campaigns"
                                )}
                              </Typography>
                            }
                          />
                        )}
                        
                      </ListItem>
                    </Tooltip>
                    
                  </>
                )}
              />
            )}

            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <>
                  <Tooltip
                    placement="right"
                    arrow
                    title={
                      collapsed ? (
                        <Typography
                          style={{
                            fontWeight: 700,
                            fontSize: "0.9rem",
                          }}
                        >
                          {i18n.t(
                            "mainDrawer.listItems.flowbuilder"
                          )}
                        </Typography>
                      ) : (
                        ""
                      )
                    }
                  >
                    <ListItem
                      style={{display:"none"}} data-guide="menu-flows"
                      dense
                      button
                      className={`${classes.listItem} ${
                        isFlowbuilderRouteActive
                          ? classes.listItemActive
                          : ""
                      } ${collapsed ? classes.listItemIconOnly : ""}`}
                      onClick={() =>
                        setOpenFlowSubmenu((prev) => !prev)
                      }
                      onMouseEnter={() => setFlowHover(true)}
                      onMouseLeave={() => setFlowHover(false)}
                    >
                      <ListItemIcon
                        className={`${classes.listItemIcon} ${
                          collapsed ? classes.listItemIconOnlyWrap : ""
                        }`}
                      >
                        <Avatar
                          variant="rounded"
                          className={classes.iconHoverActive}
                          style={
                            isFlowbuilderRouteActive || flowHover
                              ? {
                                  color: "#ffffff",
                                  background:
                                    iconStyles.flowbuilder.gradient,
                                  boxShadow:
                                    "0 8px 16px -12px rgba(15, 23, 42, 0.65)",
                                }
                              : {
                                  color: iconStyles.flowbuilder.color,
                                  ...inactiveIconSurface,
                                }
                          }
                        >
                          <Webhook />
                        </Avatar>
                      </ListItemIcon>
                      {!collapsed && (
                        <ListItemText
                          className={classes.listItemText}
                          primary={
                            <Typography className={classes.listItemLabel}>
                              {i18n.t(
                                "mainDrawer.listItems.flowbuilder"
                              )}
                            </Typography>
                          }
                        />
                      )}
                      {!collapsed &&
                        (openFlowSubmenu ? (
                          <ExpandLessIcon
                            className={classes.groupExpandIcon}
                          />
                        ) : (
                          <ExpandMoreIcon
                            className={classes.groupExpandIcon}
                          />
                        ))}
                    </ListItem>
                  </Tooltip>

                  <Collapse
                    in={!collapsed && openFlowSubmenu}
                    timeout="auto"
                    unmountOnExit
                    className={classes.submenuSection}
                  >
                    <List dense component="div" disablePadding>
                      <ListItemLink
                        to="/phrase-lists"
                        primary={i18n.t(
                          "flowbuilder.subMenus.campaign"
                        )}
                        icon={<EventAvailableIcon />}
                        iconKey="flowbuilder"
                        tooltip={collapsed}
                      />

                      <ListItemLink
                        to="/flowbuilders"
                        primary={i18n.t(
                          "flowbuilder.subMenus.conversation"
                        )}
                        icon={<ShapeLine />}
                        iconKey="flowbuilder"
                        tooltip={collapsed}
                      />
                    </List>
                  </Collapse>
                </>
              )}
            />

            {user.super && (
              <ListItemLink
                to="/announcements"
                primary={i18n.t(
                  "mainDrawer.listItems.annoucements"
                )}
                icon={<AnnouncementIcon />}
                iconKey="announcements"
                tooltip={collapsed}
              />
            )}

            {showExternalApi && (
              <>
                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <ListItemLink
                      to="/messages-api"
                      primary={i18n.t(
                        "mainDrawer.listItems.messagesAPI"
                      )}
                      icon={<CodeRoundedIcon />}
                      iconKey="api"
                      tooltip={collapsed}
                    />
                  )}
                />
              </>
            )}
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  guideId="menu-team"
                  to="/users"
                  primary={i18n.t("mainDrawer.listItems.users")}
                  icon={<PeopleAltOutlinedIcon />}
                  iconKey="users"
                  tooltip={collapsed}
                />
              )}
            />
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  guideId="menu-sectors"
                  to="/queues"
                  primary={i18n.t("mainDrawer.listItems.queues")}
                  icon={<AccountTreeOutlinedIcon />}
                  iconKey="queues"
                  tooltip={collapsed}
                />
              )}
            />

            {showOpenAi && (
              <Can
                role={user.profile}
                perform="dashboard:view"
                yes={() => (
                  <>
                    {!collapsed && (
                      <Divider className={classes.sectionDivider} />
                    )}
                    <Tooltip
                      placement="right"
                      arrow
                      title={collapsed ? <Typography style={{ fontWeight: 700, fontSize: "0.9rem" }}>Korax IA</Typography> : ""}
                    >
                      <li>
                        <ListItem
                          data-guide="menu-korax-ai"
                          button
                          component={React.forwardRef((props, ref) => (
                            <RouterLink ref={ref} to="/prompts" {...props} />
                          ))}
                          className={`${classes.listItem} ${location.pathname === "/prompts" ? classes.listItemActive : ""} ${collapsed ? classes.listItemIconOnly : ""}`}
                          style={{
                            margin: "2px 4px",
                            borderRadius: "9px",
                            background: location.pathname === "/prompts"
                              ? "rgba(255,255,255,0.07)"
                              : "transparent",
                            border: "none",
                            width: "calc(100% - 8px)",
                          }}
                        >
                          <ListItemIcon className={`${classes.listItemIcon} ${collapsed ? classes.listItemIconOnlyWrap : ""}`}>
                            <Avatar
                              variant="rounded"
                              className={classes.iconHoverActive}
                              style={{
                                background: "linear-gradient(135deg, #0066FF 0%, #00A3FF 100%)",
                                color: "#ffffff",
                                boxShadow: "0 4px 12px rgba(0,102,255,0.4)",
                                width: 32,
                                height: 32,
                              }}
                            >
                              <SmartToyOutlinedIcon style={{ fontSize: 18 }} />
                            </Avatar>
                          </ListItemIcon>
                          {!collapsed && (
                            <ListItemText
                              className={classes.listItemText}
                              primary={
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography style={{
                                    fontWeight: 600,
                                    fontSize: "0.875rem",
                                    color: "#C8D3E8",
                                    letterSpacing: "0",
                                  }}>
                                    Korax IA
                                  </Typography>
                                  <Chip
                                    label="AI"
                                    size="small"
                                    style={{
                                      height: 16,
                                      fontSize: "0.6rem",
                                      fontWeight: 700,
                                      background: "rgba(255,255,255,0.08)",
                                      color: "rgba(200,211,232,0.7)",
                                      border: "none",
                                    }}
                                  />
                                </Box>
                              }
                            />
                          )}
                        </ListItem>
                      </li>
                    </Tooltip>
                    {!collapsed && (
                      <Divider className={classes.sectionDivider} />
                    )}
                  </>
                )}
              />
            )}

            {showIntegrations && (
              <Can
                role={user.profile}
                perform="dashboard:view"
                yes={() => (
                  <ListItemLink
                    guideId="menu-integrations"
                    to="/queue-integration"
                    primary={i18n.t(
                      "mainDrawer.listItems.queueIntegration"
                    )}
                    icon={<DeviceHubOutlined />}
                    iconKey="integrations"
                    tooltip={collapsed}
                  />
                )}
              />
            )}
            <Can
              role={
                user.profile === "user" &&
                user.allowConnections === "enabled"
                  ? "admin"
                  : user.profile
              }
              perform={"drawer-admin-items:view"}
              yes={() => (
                <ListItemLink
                  guideId="menu-whatsapp"
                  to="/connections"
                  primary={i18n.t(
                    "mainDrawer.listItems.connections"
                  )}
                  icon={
                    <SignalCellularConnectedNoInternet4BarIcon />
                  }
                  iconKey="connections"
                  showBadge={connectionWarning}
                  tooltip={collapsed}
                />
              )}
            />
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  guideId="menu-files"
                  to="/files"
                  primary={i18n.t("mainDrawer.listItems.files")}
                  icon={<AttachFile />}
                  iconKey="files"
                  tooltip={collapsed}
                />
              )}
            />
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  guideId="menu-financial"
                  to="/financeiro"
                  primary="Assinatura"
                  icon={<LocalAtmIcon />}
                  iconKey="financial"
                  tooltip={collapsed}
                />
              )}
            />
            <ListItemLink
              guideId="menu-quick-messages"
              to="/quick-messages"
              primary="Respostas rápidas"
              icon={<FlashOnIcon />}
              iconKey="messages"
              tooltip={collapsed}
            />

            <Can
              role={user.profile}
              perform={"drawer-admin-items:view"}
              yes={() => (
                <ListItemLink
                  guideId="menu-queues"
                  to="/queues"
                  primary="Setores"
                  icon={<AccountTreeOutlinedIcon />}
                  iconKey="queues"
                  tooltip={collapsed}
                />
              )}
            />

            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/settings"
                  primary={i18n.t(
                    "mainDrawer.listItems.settings"
                  )}
                  icon={<SettingsOutlinedIcon />}
                  iconKey="settings"
                  tooltip={collapsed}
                />
              )}
            />

            {user.super && (
              <ListItemLink
                to="/dashboard-master"
                primary="Dashboard Master"
                icon={
                  <span style={{ fontSize: 16 }}>
                    📊
                  </span>
                }
                iconKey="dashboardMaster"
                tooltip={collapsed}
              />
            )}
            {user.super && (
              <ListItemLink
                to="/dashboard-master/acquisition"
                primary="Aquisição"
                icon={
                  <span style={{ fontSize: 16 }}>
                    📈
                  </span>
                }
                iconKey="masterAcquisition"
                tooltip={collapsed}
              />
            )}

            {user.super && (
              <ListItemLink
                to="/dashboard-master/plans"
                primary="Gestão de Planos"
                icon={
                  <span style={{ fontSize: 16 }}>
                    ⚙️
                  </span>
                }
                iconKey="masterPlans"
                tooltip={collapsed}
              />
            )}

            {user.super && (
              <ListItemLink
                to="/ai-credits-admin"
                primary="Créditos Admin"
                icon={<span style={{fontSize:16}}>⚡</span>}
                iconKey="financial"
                tooltip={collapsed}
              />
            )}
            {user.super && (
              <ListItemLink
                to="/global-config"
                primary={i18n.t(
                  "globalConfig.title",
                  "Configurações Globais"
                )}
                icon={<SettingsApplications />}
                iconKey="globalConfig"
                tooltip={collapsed}
              />
            )}
          </>
        )}
      />
      {!collapsed && (
        <React.Fragment>
          <Divider className={classes.sectionDivider} />
          <Box className={classes.versionWrap}>
            <Chip
              label="V15.0.2"
              size="small"
              className={classes.versionChip}
            />
          </Box>
        </React.Fragment>
      )}
    </div>
  );
};

export default MainListItems;
